import { render } from "./AssetListType.vue?vue&type=template&id=4d245e3e"
import script from "./AssetListType.vue?vue&type=script&lang=js"
export * from "./AssetListType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/Upwork/kaz/plus studio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__